import React from 'react';
import PropTypes from 'prop-types';
import features from '../lib/common/features';

const BestAvailableLink = () => {
  const bestAvailableUrl = features.getOption('bestAvailableLink', 'url');
  const bestAvailableLabel = features.getOption('bestAvailableLink', 'labelText');

  return bestAvailableUrl ? (
    <a className="u-mini-link" href={`${bestAvailableUrl}`}>
      {bestAvailableLabel}
    </a>
  ) : null;
};
BestAvailableLink.propTypes = {
  currentPerformanceId: PropTypes.number.isRequired
};

export default BestAvailableLink;



// WEBPACK FOOTER //
// ./src/javascripts/components/BestAvailableLink.js